export var RiskLevel;
(function (RiskLevel) {
    RiskLevel[RiskLevel["Lower"] = 0] = "Lower";
    RiskLevel[RiskLevel["Increasing"] = 1] = "Increasing";
    RiskLevel[RiskLevel["Higher"] = 2] = "Higher";
    RiskLevel[RiskLevel["High"] = 3] = "High";
})(RiskLevel || (RiskLevel = {}));
//# sourceMappingURL=RiskLevel.js.map